var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 28,
    viewBox: "0 0 16 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88293 28H5.36861C4.61459 28 4.00118 27.3908 4.00118 26.6418V16.528H1.36742C0.613347 16.528 0 15.9185 0 15.1698V10.836C0 10.087 0.613347 9.47778 1.36742 9.47778H4.00118V7.30756C4.00118 5.15572 4.68143 3.325 5.96819 2.01354C7.26079 0.696172 9.06719 0 11.1921 0L14.6349 0.00557812C15.3876 0.00683594 16 0.616109 16 1.36374V5.38759C16 6.13654 15.3868 6.74581 14.633 6.74581L12.315 6.74663C11.608 6.74663 11.428 6.8874 11.3895 6.93055C11.3261 7.00219 11.2506 7.20442 11.2506 7.76305V9.47762H14.4588C14.7003 9.47762 14.9343 9.53679 15.1354 9.64824C15.5692 9.88903 15.8389 10.3442 15.8389 10.8362L15.8372 15.17C15.8372 15.9185 15.2238 16.5278 14.4698 16.5278H11.2505V26.6418C11.2506 27.3908 10.637 28 9.88293 28ZM5.65375 26.3585H9.59773V15.7932C9.59773 15.2931 10.0075 14.8864 10.5107 14.8864H14.1846L14.1861 11.1193H10.5105C10.0073 11.1193 9.59773 10.7126 9.59773 10.2125V7.76311C9.59773 7.12184 9.66336 6.39253 10.1507 5.84434C10.7396 5.18169 11.6676 5.10524 12.3145 5.10524L14.3474 5.10437V1.64659L11.1908 1.6415C7.77586 1.6415 5.65381 3.81276 5.65381 7.30762V10.2125C5.65381 10.7123 5.24429 11.1193 4.741 11.1193H1.65262V14.8863H4.741C5.24429 14.8863 5.65381 15.2931 5.65381 15.7931L5.65375 26.3585Z",
    fill: "url(#paint0_linear_1065_357)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1065_357",
    x1: 0,
    y1: 0,
    x2: 23.4899,
    y2: 18.4793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.40c57df09633d58d480f82a0b99c080a.svg";
export { ForwardRef as ReactComponent };